module.exports = __webpack_public_path__ + "1793882494189/images/owl.video.play.4a37f80.png";